// A failed, already-complete image will never emit another load/error event.
export function waitForReportImage(
  img: HTMLImageElement,
  timeoutMs = 15000,
): Promise<void> {
  if (img.complete) return Promise.resolve()
  return new Promise((resolve, reject) => {
    const cleanup = () => {
      clearTimeout(timer)
      img.removeEventListener('load', done)
      img.removeEventListener('error', done)
    }
    const done = () => {
      cleanup()
      resolve()
    }
    const timer = setTimeout(() => {
      cleanup()
      reject(new Error('A report image is still loading. Please try again.'))
    }, timeoutMs)
    img.addEventListener('load', done, { once: true })
    img.addEventListener('error', done, { once: true })
    if (img.complete) done()
  })
}
